/* eslint-disable @typescript-eslint/no-use-before-define */
import { toHardware } from '@studio/models/agent';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { Props } from './types.js';
import { broker } from '#~/agent/index.js';
import { getCurrentVendor } from '@studio/design-system/themes/vendor.js';

const resolveEmbeddedAgentIcon = (agent: Props['agent']): string => {
  const proxy = broker.acquire(agent.id);

  if (proxy?.iconUrl) {
    return proxy.iconUrl;
  }

  if (agent.iconUrl) {
    return agent.iconUrl;
  }

  return resolveAgentIcon(agent);
};

const resolveAgentIcon = (agent: Props['agent']): string =>
  `/assets/agents/${toHardware(agent)}.png`;

const iconMap = {
  ptzoptics: '/assets/ptzoptics/hive_badge_2.png',
  iris: '/assets/icons/iris_badge.png'
};

const productNameMap = {
  ptzoptics: 'Hive',
  iris: 'Iris'
};

/** Agent `<Icon>` component. */
export const Icon = ({ agent, className, ...props }: Props): ReactElement => {
  const theme = getCurrentVendor();

  const icon = iconMap[theme] ?? iconMap.iris;
  const productName = productNameMap[theme] ?? productNameMap.iris;

  return (
    <div className='relative'>
      <img
        alt={agent.name}
        className={twMerge('w-[150px]', className)}
        src={agent.embedded ? resolveEmbeddedAgentIcon(agent) : resolveAgentIcon(agent)}
        {...props}
      />
      {!!agent.embedded && (
        <img
          alt={`${productName} Enabled Device`}
          className={twMerge('absolute bottom-[-5px] right-[15px] w-[50px]', className)}
          src={icon}
        />
      )}
    </div>
  );
};
